import React from 'react';
import {Box, Flex} from "@chakra-ui/layout";
import Header from "./Header";
import Intro from "./Intro";
import Footer from "./Footer";
import About from "./About";

export default function Home() {
  return (
    <>
      <Box bgColor={"brand.orange"}>
        <Header />
        <Intro />
      </Box>
      <Box>
        <About />
      </Box>
      <Box>
        <Footer />
      </Box>
    </>
  )
}
